import axios from "axios";

export const REQUEST_OVERDRAFT = async (data) => {
  return axios
    .post(`${process.env.REACT_APP_BASE_URL}liquidity/request`, data)
    .then((res) => {
      return res.data;
    });
};
